import './common/config/config.sentry.js'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { Provider } from 'react-redux'
import { store } from '../src/common/redux/store/store.js'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './common/utils/functions/queryClient.js'

ReactDOM.createRoot(document.getElementById('root')).render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <App />
    </Provider>
  </QueryClientProvider>
)
